import { render, staticRenderFns } from "./LightControlMenu.vue?vue&type=template&id=50de3f50&scoped=true"
import script from "./LightControlMenu.vue?vue&type=script&lang=js"
export * from "./LightControlMenu.vue?vue&type=script&lang=js"
import style0 from "./LightControlMenu.vue?vue&type=style&index=0&id=50de3f50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50de3f50",
  null
  
)

export default component.exports